module.exports = __webpack_public_path__ + "static/media/law.bcbc91e6.svg";